module.exports = __webpack_public_path__ + "bm.svg?012b04b78dff697d63abb50a1193144c";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/bm.svg
// module id = 1007
// module chunks = 0